export const TermsNewContent = {
  pageTitle: `Sign agreement and submit your request`,
  IRAEstatePageTitle: `Review and sign new account agreements`,
  continueButton: `Agree and sign`,
  submitButton: `Submit application`,
  errorMsg: `This field is required.`,
  aboutBrokerage: {
    header: `About opening your new brokerage account(s)`,
    sections: [
      {
        content: [
          `You are opening account(s) through Vanguard Brokerage Services® (VBS), a division of Vanguard Marketing Corporation (VMC), member FINRA and SIPC, to purchase and sell stocks, bonds, ETFs, Vanguard and non-Vanguard mutual funds, and other securities. Assets identified in this change of ownership application will be transferred into this new account.`,
        ],
      },
      {
        header: `Review Form CRS`,
        iraEstateHeader: `Review our Form CRS`,
        content: [
          `Please read Form CRS presented below to help you better understand the services, fees, costs, conflicts, and conduct standards that apply to your relationship with Vanguard Brokerage Services: <a class="link-underline" href="https://personal.vanguard.com/pdf/vmccrs.pdf" target="_blank" rel="noopener noreferrer">Form CRS</a>`,
        ],
      },
      {
        content: [
          `Please read Form CRS presented below to help you better understand the services, fees, costs, conflicts, and conduct standards that apply to your relationship with Vanguard Brokerage Services.`,
          `<a class="link-underline" href="https://personal.vanguard.com/pdf/vmccrs.pdf" target="_blank" rel="noopener noreferrer"><b>Form CRS (PDF)</b></a>`,
        ],
      },
      {
        content: [
          `You previously consented to electronically receive documents related to your Vanguard accounts. Below are electronic copies of documents related to your new account.`,
        ],
      },
    ],
  },
  trustToTrustNewAccount: {
    content: [
      `You previously consented to electronically receive documents related to your Vanguard accounts. Below are electronic copies of documents related to your new account.<br>`,
      `Please read our Form CRS presented below to help you better understand the services, fees, costs, conflicts, and conduct standards that apply to your relationship with Vanguard Brokerage Services.<br>`,
    ],
    documents: [
      {
        link: 'https://personal1.vanguard.com/pdf/v814.pdf',
        text: 'Form CRS (PDF)',
      },
      {
        link: 'https://personal1.vanguard.com/pdf/vbsaacp.pdf',
        text: 'Vanguard Brokerage Account Agreement (PDF)',
      },
      {
        link: 'https://investor.vanguard.com/trust-security/privacy-center/online-privacy-notice',
        text: `Vanguard's Privacy Policy (Website)`,
      },
      {
        link: 'https://personal1.vanguard.com/pdf/v414.pdf',
        text: 'Vanguard Brokerage Services commission and fee schedules (PDF)',
      },
      {
        link: 'https://personal1.vanguard.com/pdf/s845.pdf',
        text: 'Business Contingency Planning and Disaster Recovery Programs at Vanguard (PDF)',
      },
    ],
  },
  certificationOfBene: {
    header: `Certification of beneficiary`,
    description: `As a beneficiary, I hereby certify that:`,
    bullets: [
      `I am a beneficiary of the decedent’s retirement assets.`,
      `The beneficiary/ies identified in this application constitute all the members of the group of beneficiaries designated by the decedent, including any and all beneficiaries who may be entitled to a share of the decedent’s retirement assets on the basis of a designation made per stirpes, and to the best of my knowledge, there are no other persons or entities entitled to a share of the decedent’s retirement assets as a member of the group of beneficiaries.`,
      `I agree to indemnify and hold harmless The Vanguard Group, Inc., Vanguard Marketing Corporation, their affiliates, each of the investment company members of The Vanguard Group, and their respective officers, directors, employees, and agents (collectively, “Vanguard”) from any liability, cost, or damage of any kind that Vanguard incurs for relying in good faith upon the information provided by me/us in this application.`,
      `I agree to provide any additional documentation required by Vanguard to transfer the decedent’s retirement assets to the beneficiary/ies.`,
      `The information contained in this application is correct and complete to the best of my knowledge.`,
      `I agree to return any funds or securities disbursed to me in error upon request from Vanguard.`,
    ],
  },
  consentElectronicDelivery: {
    header: `Consent to electronic delivery`,
    sections: [
      {
        content: [
          `How to access online documents:`,
          `To view and print the documents listed below, you'll need software that reads PDF files. If you can’t obtain the documents, or you don’t consent to electronic delivery, you can’t submit an application through this process. Contact us to request a free copy of these documents. Vanguard won’t charge you for using our website (but you could incur expenses from your service provider). Internet service providers may occasionally experience system failures, and hyperlinks may fail to function properly.`,
        ],
      },
      {
        content: [
          `Duration of electronic consent: `,
          `This election and consent applies only to the documents required to complete this specific transaction.`,
          `By clicking <b>I sign and agree</b> below, you consent to receive the Form CRS above and the following documents electronically and acknowledge having reviewed, printed, or otherwise received them.`,
          `Settlement fund documents (as applicable)`,
          `Vanguard Federal Money Market Fund (PDF)`,
          `You can also review the fund's prospectus at the bottom of your confirmation page once completing this application.`,
          `Additional document for SEP-IRA Accounts`,
          `In order for you to open an account, Vanguard must provide you with some important documents, link(s) to which appear below . By clicking <b>I sign and agree</b>, you consent to receive these documents electronically under the terms set forth below. You also agree to read and agree to the terms of these documents before investing. `,
          `By clicking <b>I sign and agree</b> below, you consent to accepting these documents electronically, including Form CRS above, and acknowledge having reviewed or saved them.`,
        ],
        links: {
          allAcctsHeading: `<b>For all account types: </b>`,
          allAccounts: [
            {
              text: `Form CRS`,
              link: `https://personal.vanguard.com/pdf/vmccrs.pdf`,
            },
            {
              text: `Vanguard Brokerage Account Agreement`,
              link: `https://www.vanguard.com/pdf/vbsaacp.pdf`,
            },
            {
              text: `Vanguard Federal Money Market Fund (PDF)`,
              link: `https://personal.vanguard.com/pub/Pdf/sp33.pdf`,
            },
            {
              text: `Vanguard’s Privacy Policy (PDF)`,
              link: `https://investor.vanguard.com/privacy-center/online-privacy-notice`,
            },
            {
              text: `Vanguard Brokerage Services commission and fee schedules`,
              link: `https://personal1.vanguard.com/pdf/v414.pdf`,
            },
            {
              text: `Business Contingency Planning and Disaster Recovery Programs at Vanguard`,
              link: `http://www.vanguard.com/pdf/s845.pdf`,
            },
          ],
          settlementFundHeading: `<b>Settlement funds (as applicable): </b>`,
          settlementFunds: [
            {
              text: `Vanguard Federal Money Market Fund (PDF)`,
              link: `https://personal.vanguard.com/pub/Pdf/sp33.pdf`,
            },
            {
              text: `Vanguard Bank Sweep Products Terms Of Use (PDF) - Vanguard Cash Deposit`,
              link: `https://personal.vanguard.com/pdf/Bank_Sweep_Terms_of_Use.pdf`,
            },
          ],
          retireAcctsHeading: `<b>For retirement accounts: </b>`,
          retirementAccts: [
            {
              text: `The Vanguard Traditional IRA, SEP-IRA, and Roth IRA Disclosure Statement and Custodial Account Agreement`,
              link: `https://personal.vanguard.com/pdf/s831.pdf`,
            },
            {
              text: `5305 SEP-IRA Contribution Agreement`,
              link: `https://personal.vanguard.com/pdf/s821.pdf`,
              addInfo: `and if you're opening a SEP-IRA, `,
            },
          ],
        },
        iraEstateLinks: {
          links: [
            {
              text: `Vanguard Brokerage Account Agreement (PDF)`,
              link: `https://www.vanguard.com/pdf/vbsaacp.pdf`,
            },
            {
              text: `Vanguard’s Privacy Policy (Website)`,
              link: `https://investor.vanguard.com/investing/privacy-policy`,
            },
            {
              text: `Vanguard Brokerage Services commission and fee schedules (PDF)`,
              link: `https://personal1.vanguard.com/pdf/v414.pdf`,
            },
            {
              text: `Business Contingency Planning and Disaster Recovery Programs at Vanguard (PDF)`,
              link: `http://www.vanguard.com/pdf/s845.pdf`,
            },
            {
              text: `The Vanguard Traditional IRA, SEP-IRA, and Roth IRA Disclosure Statement and Custodial Account Agreement (PDF)`,
              link: `https://personal.vanguard.com/pdf/s831.pdf`,
            },
          ],
          iraLinks: [
            {
              text: `5305 SEP-IRA Contribution Agreement (PDF)`,
              link: `https://personal.vanguard.com/pdf/s821.pdf`,
              addInfo: `and if you're opening a SEP-IRA, `,
            },
          ],
          formsLinks: [
            {
              text: `Form CRS (PDF)`,
              link: `https://personal.vanguard.com/pdf/vmccrs.pdf`,
            },
          ],
        },
      },
      {
        header: 'Access to online documents',
        content: [
          `Access to online documents To view and print the documents listed below online, you'll need software that reads PDF files such as Adobe Reader. You will also need a printer with graphics capabilities.`,
          `If you are unable to download, view, and print the documents, or you do not consent to electronic delivery, you cannot submit your application using our e-signature or print-and-mail options. Please contact Vanguard at 877-662-7447 for assistance or to receive a free copy of these documents.`,
          `Vanguard will not charge you a fee to use our website, but you could incur expenses from your internet service provider when you access information online. An internet service provider may occasionally experience system failure, and hyperlinks may fail to function properly.`,
        ],
      },
    ],
  },
  openAccountAuthorization: {
    header: 'Authorization to open a new brokerage account',
    sections: [
      `I have received and read a copy of the attached Vanguard Brokerage Account Agreement (Agreement), which contains a pre-dispute arbitration agreement. I acknowledge that my signature signifies and constitutes my agreement that this VBS Account and my relationship with Vanguard Brokerage Services will be governed by and consists of the terms set forth in the Agreement and incorporates the terms set forth in the Vanguard Brokerage Services commission and fee schedules and the other disclosures, terms, and agreements relating to my VBS Account or to particular features or services offered in connection with my VBS Account, each as amended from time to time. I understand there are fees associated with establishing, maintaining, engaging in transactions in, and transferring assets out of this VBS Account.`,
      `I hereby adopt the Vanguard Traditional IRA, SEP-IRA, and Roth IRA Custodial Account Agreement that is incorporated herin by reference, which I acknowledge having received and read. I further acknowledge having received and read the Vanguard Traditional IRA, SEP-IRA, and Roth IRA Disclosure Statement.`,
      `I understand that by clicking <b>I sign and agree</b>, I am attaching my e-signature, which is the legal equivalent of submitting a document signed by hand. Clicking <b>I sign and agree</b> and the <b>Submit application</b> button manifests my desire and intent to authorize the transfer in the manner stated on this form and the opening of a new inherited IRA estate brokerage account.`,
      `I understand that Vanguard is relying on the information I am providing in this Application. I confirm that, to the best of my knowledge, the information I have provided is true and correct as of the date hereof. I agree to indemnify and hold The Vanguard Group, Inc., Vanguard Marketing Corporation, their affiliates, and each of the investment company members of The Vanguard Group and their respective officers, employees, and agents (collectively, “Vanguard”) harmless from any liability, cost, or damage of any kind that Vanguard incurs for relying in good faith upon the information provided by me in this Application`,
      `<b>I acknowledge that this account is governed by a predispute arbitration agreement in section f on page 18 of the attached Vanguard Brokerage Account Agreement, and I have read the predispute arbitration clause.</b>`,
      `I sign and agree`,
    ],
  },
  openAccountAuthorizationTrust: {
    sections: [
      {
        content: [
          `By clicking <b>I sign and agree</b> and <b>Submit application</b>, I, as trustee, certify the following:`,
        ],
      },
      {
        content: [
          `The trust is valid and in full force and effect as of the date indicated.`,
          `The trustee has full authority under the trust document and applicable law to enter into investment transactions on behalf of the trust, including the purchase, sale, exchange, transfer, and redemption of mutual funds, trading in stocks, bonds, and other securities and contracts relating to same.`,
          `The trustee has full authority under the trust document and applicable law to engage in margin trading or options investing.`,
          `The trustee may issue general instructions.`,
          `The trustee acknowledges that Vanguard has not reviewed the trust document and understands Vanguard is relying on the statements made in this certification.`,
          `The trustee agrees to inform Vanguard of any amendment of the trust that would impact the information in this certification.`,
          `Vanguard is not responsible for interpreting or administering the trust.`,
          `All transactions effected and all instructions provided to Vanguard will be in full compliance with the trust.`,
          `The current trustee of the trust hereby declares that all statements made in this certification are true and correct to the best of trustee's knowledge, that all actions taken and instructions given by the trustee are within such authority under the trust document and applicable by law, and agree that this certification is binding upon the trust, its beneficiaries, and all future trustees. The trustee agrees, on behalf of the trust, to indemnify and hold The Vanguard Group, Inc. , Vanguard Marketing Corporation, their affiliates, and each of the investment company members of The Vanguard Group and their respective officers, employees, and agents harmless from and against all losses, claims, and expenses (including attorney fees) of any kind incurred by Vanguard for relying in good faith upon this certification.`,
        ],
      },
      {
        content: [
          `By clicking <b>I sign and agree</b> and <b>Submit application</b>, I have read and accept the terms above and the `,
          `<a c11n-link variant="primary-reinforced" href="https://www.vanguard.com/pdf/vbsaacp.pdf" target="_blank" rel="noopener noreferrer"><b>Vanguard Brokerage Account Agreement</b></a>, `,
          `the <a c11n-link variant="primary-reinforced" href="https://personal.vanguard.com/pdf/s831.pdf" target="_blank" rel="noopener noreferrer"><b>Vanguard Traditional IRA, SEP-IRA, and Roth IRA Disclosure Statement and Custodial Account Agreement</b></a> and, as applicable, `,
          `<a c11n-link variant="primary-reinforced" href="https://personal.vanguard.com/pdf/s821.pdf" target="_blank" rel="noopener noreferrer"><b>5305 SEP-IRA Contribution Agreement</b></a>. `,
          `I also authorize the transfer of the assets identified in this change of ownership application to this new brokerage account.`,
        ],
        trustToTrustContent: [
          `By clicking <b>I sign and agree</b> and <b>Submit application</b>, I have read and accept the terms above and the `,
          `<a c11n-link variant="primary-reinforced" href="https://www.vanguard.com/pdf/vbsaacp.pdf" target="_blank" rel="noopener noreferrer"><b>Vanguard Brokerage Account Agreement</b></a>, `,
          `I also authorize the transfer of the assets identified in this change of ownership application to this new brokerage account.`,
        ],
      },
    ],
  },
  taxCertification: {
    content: [
      `Tax certification: `,
      `Before you can submit your application, you also need to provide your tax certification and electronically sign account agreements below.`,
    ],
  },
  certifyStatements: {
    header: `Please certify the following tax statements`,
    description: `Under penalties of perjury, I certify that:`,
    bullets: [
      `The number shown on this form is my correct taxpayer identification number (or I am waiting 	for a number to be issued to me); and`,
      `I am not subject to backup withholding because (a) I am exempt from backup withholding, or (b) I have not been notified by the Internal Revenue Service (IRS) that I am subject to backup withholding as a result of a failure to report all interest or dividends, or (c) the IRS has informed me that I am no longer subject to backup withholding.`,
      `I am a U.S. citizen or other U.S. person (as defined in IRS Form W-9); and`,
      `The Foreign Account Tax Compliance Act (FATCA) code(s) entered on this form (if any) indicating that I am exempt from FATCA reporting is correct.`,
    ],
    exitApp: `If you can't certify the above statements, <a class="link-underline" href="https://support.vanguard.com/">please click here to exit this application</a>.`,
    IRSNotice: `<b>The IRS does not require your consent to any provision of this document other than the certifications to avoid backup withholding.</b>`,
  },
  taxCertificationStatementsCheckboxLabel: `Tax Certification: By checking this box, I certify and sign under penalty of perjury that the tax certification statements appearing above are true.`,
  signAndAgree: [
    `<b>I acknowledge that each brokerage account is governed by a pre-dispute arbitration clause in Section 9(f) on page 18 of the Vanguard Brokerage Account Agreement.</b>`,
    {
      agreeHeader: `By clicking <b>Agree and sign</b>:`,
      accountAgreement: `I have read and accept the terms and conditions above and the <a href="http://www.vanguard.com/pdf/vbsaacp.pdf" target="_blank">Vanguard Brokerage Account Agreement</a> and, if applicable, <a href="https://personal.vanguard.com/pdf/s831.pdf" target="_blank">The Vanguard Traditional IRA, SEP-IRA, and Roth IRA Disclosure Statement and Custodial Account Agreement</a>`,
      transferAgreement: `I authorize the transfer of assets as indicated in this application.`,
      beneAgreement: `I certify the beneficiary statements above.`,
    },
  ],
  loadingSpinner: `We're preparing your request... <br> please wait a few minutes`,
  importantInformation: {
    header: `<b>Important information</b><br><br>`,
    content: `Vanguard Marketing Corporation is required by federal law to obtain from each person who opens an account, and in some cases, regarding each owner or trustee, certain personal information—including name, street address, and taxpayer identification number, among other information—that will be used to verify identity. If you do not provide us with this information, we will not be able to open the account(s). If we're unable to verify your identity, Vanguard Marketing Corporation reserves the right to close your account(s) or take other steps we deem reasonable.<br><br>`,
    iraEstateContent: `Vanguard Marketing Corporation is required by federal law to obtain from each person who opens an account, and in some cases, regarding each owner or trustee, certain personal information including name, street address, and taxpayer identification number, among other information-that will be used to verify identity. If you don't provide us with this information, we won't be able to open the account. If we're unable to verify your identity, Vanguard Marketing Corporation reserves the right to close your account or take other steps we deem reasonable.<br><br>`,
  },
  importantCostBasisInformation: {
    header: `<b>Important cost basis information</b><br><br>`,
    content: `Once you submit this request, shares that use the average cost basis method will be transferred with their average basis to the different account. Additionally, any shares that remain in the original account will be locked into that average basis. This could impact your future tax planning strategies, such as gifting or charitable giving. <br><br>If you're uncertain about how to proceed or what cost basis method is used for your account, call 877-662-7447 (M–F, 8 a.m. to 8 p.m., ET).`,
  },
  internalHeader: `Crew cannot open new accounts on behalf of clients.`,
  internalDescription: `Please nudge clients eligible for CXD off the call to self submit.`,
};
